export default "__VITE_ASSET__CyiYXHKb__"